import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import style from './RecommendContent.module.css';
import URL from '../../constants/url';
import arrowR from '../../images/common/i_arrow_sm_right.svg';
import HealthInfoDetail from '../../pages/user/healthinfo/HealthInfoDetail';

/**
 * @param {Array}    items       - [{ id, thumb, title, tag }]
 * @param {function} onMoreClick - "모두 보기" 클릭
 */
const RecommendContent = ({ items, onMoreClick }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [detailId, setDetailId] = useState(null);
    const justOpenedRef = useRef(false);

    const handleClickContent = (id) => {
        // navigate(URL.HEALTH_INFORM_DETAIL, { state: { id } });
        justOpenedRef.current = true;
        setDetailId(id);
        navigate(location.pathname + location.search, { state: { detailOpen: true } });
    };

    const handleCloseDetail = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    // 뒤로가기로 state가 사라지면 팝업 닫기
    useEffect(() => {
        if (location.state?.detailOpen) {
            justOpenedRef.current = false;
            return;
        }

        if (justOpenedRef.current) return;

        if (detailId !== null && !location.state?.detailOpen) {
            setDetailId(null);
        }
    }, [location.state, detailId]);
    
    if (!items || items.length === 0) return null;

    return (
        <>
            <div className={style.contentSection}>
                <div className={style.contentHeader}>
                    <h3 className={style.contentTitle}>추천 콘텐츠</h3>
                    <button className={style.contentMore} onClick={onMoreClick}>모두 보기 <img src={arrowR} alt="모두 보기" /></button>
                </div>
                {items.map(c => (
                    <div key={c.id} className={style.contentCard} onClick={() => handleClickContent(c.id)}>
                        <div className={style.contentThumb}>
                            <img src={c.cntsThumbUrl} alt="" draggable={false} />
                        </div>
                        <div className={style.contentInfo}>
                            <p>{c.cntsSj}</p>
                            <span>{c.ctgrys}</span>
                        </div>
                    </div>
                ))}
            </div>

            {detailId !== null && (
                <HealthInfoDetail contId={detailId} onClose={handleCloseDetail} />
            )}
        </>
    );
};

export default RecommendContent;